import '@fontsource/roboto-mono/cyrillic-100.css';
import '@fontsource/roboto-mono/cyrillic-700.css';
import '@fontsource/roboto-mono/latin-100.css';
import '@fontsource/roboto-mono/latin-700.css';
import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';

const getScaleButton = () => document.querySelector('.widget-tab__panorama-controls-button--scale');
const getRulerButton = () => document.querySelector('.widget-tab__panorama-controls-button--ruler');
const getFloorsSelect = () => document.querySelector('.floors-select');
const getTabButtons = () => document.querySelector('.widget-tab-buttons');
const getButton2D = () => document.querySelectorAll('.widget-tab-button')[0];
const getButton3D = () => document.querySelectorAll('.widget-tab-button')[1];

const Config = {
  urls: {
    production: 'https://backend.estate.hart-digital.com',
    stage: 'https://backend-stage.estate.hart-digital.com',
  },
  hidePreloaderDelay: 500,
};

const hidePreloader = () => document.querySelector('.widget-preloader-frame').classList.add('hidden');

const removeButtonsAndHideContainer = () => {
  const controlsContainer = document.querySelector('.widget-tab__panorama-controls');
  controlsContainer.style.display = 'none';
};

const start3DTime = () => {
  const onUpdate = () => {
    const buttons = getTabButtons();
    const floorsSelect = getFloorsSelect();
    const scale = getScaleButton();
    const ruler = getRulerButton();

    console.log(buttons, floorsSelect, scale, ruler);

    if (scale && buttons) {
      buttons.append(scale);
      if (ruler) buttons.append(ruler);
      if (floorsSelect) buttons.append(floorsSelect);
      clearInterval(timer);
    }
  }

  const timer = setInterval(onUpdate, 100);
};

const start2DTime = () => {
  const onUpdate = () => {
    const buttons = getTabButtons();
    const arrows = document.querySelector('.widget-tab__isometry-arrows');
    if (buttons && arrows) {
      buttons.append(arrows.cloneNode(true));
      copyWidgetEvents();
      clearInterval(timer);
    }
  };

  const timer = setInterval(onUpdate, 100);
};

const copyWidgetEvents = () => {
  document.querySelector('.widget-tab-buttons .widget-tab__isometry-arrow--prev').addEventListener('click', () => {
    document.querySelector('.widget-tab__rotation .widget-tab__isometry-arrow--prev').click();
    document.querySelector('.widget-tab-buttons span').innerHTML = document.querySelector('.widget-tab__rotation span').innerHTML;
  });
  document.querySelector('.widget-tab-buttons .widget-tab__isometry-arrow--next').addEventListener('click', () => {
    document.querySelector('.widget-tab__rotation .widget-tab__isometry-arrow--next').click();
    document.querySelector('.widget-tab-buttons span').innerHTML = document.querySelector('.widget-tab__rotation span').innerHTML;
  });
  document.querySelector('.widget-tab__isometry-button').addEventListener('click', () => {
    document.querySelector('.widget-tab-buttons .widget-tab__isometry-arrows').remove();
    start2DTime();
  });
};

const redesignButtons = () => {
  start3DTime();
  start2DTime();

  getButton2D().innerHTML = '2D';
  getButton3D().innerHTML = '3D';

  document.addEventListener('click', (e) => {
    if (e.target.innerHTML === '2D') {
      const buttons = getTabButtons();
      const ruler = getRulerButton();
      const scale = getScaleButton();
      if (ruler) buttons.removeChild(ruler);
      if (scale) buttons.removeChild(scale);
      start3DTime();
    }
    else if (e.target.innerHTML === '3D') {
      const buttons = getTabButtons();
      const arrows = document.querySelector('.widget-tab__isometry-arrows');
      buttons.removeChild(arrows);
      start2DTime();
    }
  });
};

const getParams = () => {
  const { searchParams } = new URL(document.location);
  return {
    planId: searchParams.get('id'),
    crmPlanId: searchParams.get('crmPlanId'),
    env: (searchParams.get('env') || 'production').toLowerCase(),
    lang: (searchParams.get('lang') || 'en').toLowerCase(),
    primaryCameraPointId: searchParams.get('primaryCameraPointId'),
  }
}

const createWidget = async () => {
  const { planId, crmPlanId, env, lang, primaryCameraPointId } = getParams();

  const apiUrl = Config.urls[env] || Config.urls['production'];
  const widgetApiHandler = new ApiStore(apiUrl);
  const planData = crmPlanId
    ? await widgetApiHandler.loadCrmWidgetData(crmPlanId)
    : await widgetApiHandler.loadWidgetData(planId);

  const isRuLang = lang === 'ru';
  if (isRuLang) {
    document.getElementById('widget').classList.add('widget-ru');
  }

  const defaultRulerFontSize = 38;

  const options = {
    ...planData.parsed,
    API_URL: apiUrl,
    rotationMode: rotationModes.DEFAULT,
    tabs: ['panorama', 'rotation'],
    locale: isRuLang ? 'evometaRu' : 'evometa',
    colors: {
      main: '#FFD180',
      mainText: '#252525',
    },
    dictionaryOverrides: {
      floor: '$0',
      floorNumberEndings: {
        1: 'Ground Floor',
        2: 'First Floor',
        3: 'Second Floor'
      },
      'instructions-hint-text': 'The 3D tours are for illustrative purposes only; actual design and measurements may slightly vary' 
    },
    floorNumberEndingsVisible: true,
    scales: ['x05', 'x1'],
    scaleButtonType: 'text',
    forceTopViewOnMap: false,
    primaryCameraPointId,
    designType: 'custom',
    bottombarContent: ['ruler', 'scale', 'floors'],
    sidebarContent: [],
    tabsButtonsDesign: 'two',
    cursorType: 'circle',
    enableCursorPulse: false,
    pointHoverScale: 1.5,
    movementType: 'intraroom',
    enableDoorVisibility: true,
    rulerOptions: {
      fontSize: defaultRulerFontSize * 2,
    },
    linkOptions: {
      enablePulse: true,
      pulseSpeed: 0.6
    },
    integrations: {
      sentry: {
        dsn: 'https://62f653a9fc5368353dd83fba4017f1dd@sentry.hart-digital.com/16'
      }
    }
  };

  new Widget('#widget', options);
};

createWidget()
  .then(() => {
    redesignButtons();
    setTimeout(hidePreloader, Config.hidePreloaderDelay);
  })
  .catch((e) => {
    hidePreloader();
    const errorMessage = document.querySelector('.error-message');
    if (errorMessage) errorMessage.innerHTML = e.message;
  });
